module.exports = __webpack_public_path__ + "static/media/logo_small.3b0a473c.png";